export const AUTH_LOADING = 'AUTH_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_MFA_SESSION_ID = 'SET_MFA_SESSION_ID';
export const NOT_AUTHORIZED = 'NOT_AUTHORIZED';
